// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:6X_665 */\na.ybYK5{color:var(--audio-action-link-default);-webkit-text-decoration:underline;text-decoration:underline}.yw8HB{color:var(--audio-content-secondary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "ybYK5",
	"plain": "yw8HB"
};
export default ___CSS_LOADER_EXPORT___;
